import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Package, Plus } from 'lucide-react'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Product } from '@tagadapay/crm-entities'
import { VariantsTable } from './VariantsTable'
import { Button } from '@/components/ui/button'
import { useStoreNavigate } from '@/hooks/use-app-navigate'

interface ProductVariantsTabProps {
    product: Product.ProductWithRelations
}

export const ProductVariantsTab = ({ product }: ProductVariantsTabProps) => {
    const { t } = useTranslation('products')
    const { storeRoutes, navigate, id: storeId } = useStoreNavigate();
    const handleCreateVariant = () => {
        navigate(storeRoutes.VARIANT_CREATE(product.id))
    }

    if (!product.variants || product.variants.length === 0) {
        return (
            <Card>
                <CardHeader>
                    <div className="flex items-center justify-between">
                        <CardTitle>{t('variants')}</CardTitle>
                        <Button onClick={handleCreateVariant} size="sm">
                            <Plus className="mr-2 h-4 w-4" />
                            {t('createVariant')}
                        </Button>
                    </div>
                </CardHeader>
                <CardContent className="py-8">
                    <div className="text-center text-muted-foreground">
                        <Package className="mx-auto h-12 w-12 mb-2" />
                        <p>{t('noVariants')}</p>
                    </div>
                </CardContent>
            </Card>
        )
    }

    return (
        <Card>
            <CardHeader>
                <div className="flex items-center justify-between">
                    <CardTitle>{t('variants')}</CardTitle>
                    <Button onClick={handleCreateVariant} size="sm">
                        <Plus className="mr-2 h-4 w-4" />
                        {t('createVariant')}
                    </Button>
                </div>
            </CardHeader>
            <CardContent className="pt-6">
                <VariantsTable
                    variants={product.variants}
                    productId={product.id}
                    storeId={storeId!}
                />
            </CardContent>
        </Card>
    )
}

